(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["whatsapp-concierge"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-whatsapp-concierge]');

    if (!link || typeof window.gtag !== 'function') return;

    window.gtag('event', 'whatsapp_click', {
      link_url: link.href,
      page_location: window.location.href,
      page_title: document.title,
      whatsapp_context: link.dataset.whatsappContext
    });
  });
  } catch(e) { console.error(e); }
})();

})();
